import { render, staticRenderFns } from "./HowToUse2.vue?vue&type=template&id=5ed68b80&"
import script from "./HowToUse2.vue?vue&type=script&lang=js&"
export * from "./HowToUse2.vue?vue&type=script&lang=js&"
import style0 from "./HowToUse2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports